
import React, { ChangeEvent } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GalleryItem } from '../types/GalleryItem';
import DatePicker from "react-datepicker";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { getFileIcon } from "../../../utils";

const FileItem = ({item, handleGalleryItemChange, handleRemoveItem}: {item:GalleryItem, handleGalleryItemChange: Function, handleRemoveItem: Function}) => {
    
    const getDisplayMeta = (url: string) => {
        const parts = url.split('/');
        const fileName = parts[parts.length - 1];
        const decoded = decodeURIComponent(fileName).split('/');
        const name = decoded[decoded.length -1];
        const icon: IconProp = getFileIcon(fileName);
        return (<>
            <FontAwesomeIcon style={{ display: "block", margin: "1rem auto 1rem" }} size="3x" icon={icon} />
            <small style={{ display: "block", textAlign: "center" }}>{name}</small>
        </>)
    };
    
    return <Card key={item.url ? item.url : item?.image?.original} className="p-3">
    <div style={{ width: "100%", height: "144px", overflow: "hidden", position: "relative", cursor: "pointer" }}>
        <Button variant="outline-danger" onClick={() => handleRemoveItem(item)} style={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
            <FontAwesomeIcon icon="trash-alt" />
        </Button>
        <div style={{ maxHeight: "140px", position: "absolute", top: "0", left: "0", bottom: "0", right: "0", width: "auto" }} className="m-auto">{getDisplayMeta(item?.url || '')}</div>
    </div>
    <Card.Body className="p-0">
        <Form.Group className="mt-3">
            <Form.Label>Label</Form.Label>
            <Form.Control onChange={(event: ChangeEvent<any>) => {
                const changed: string = event.target.value || '';
                const changedItem: GalleryItem = { ...item };
                changedItem.label = changed;
                handleGalleryItemChange(changedItem);
            }} placeholder="Label" defaultValue={item.label} type="text" />
        </Form.Group>
        <Form.Group className="mt-3">
            <Form.Label>Description</Form.Label>
            <Form.Control onChange={(event: ChangeEvent<any>) => {
                const changed: string = event.target.value || '';
                const changedItem: GalleryItem = { ...item };
                changedItem.description = changed;
                handleGalleryItemChange(changedItem);
            }} placeholder="Description" defaultValue={item.description} type="text" />
        </Form.Group>
        
        <Form.Label>Valid Dates</Form.Label>
        <div>
            <DatePicker selected={item?.startDate} placeholderText="Start Date" onChange={date => {
                const changedItem = { ...item };
                changedItem.startDate = date as Date;
                handleGalleryItemChange(changedItem);
            }
            }
                selectsStart
                startDate={item?.startDate}
                endDate={item?.endDate} />
            <DatePicker className="mt-2" selected={item?.endDate} placeholderText="End Date" onChange={date => {
                const changedItem = { ...item };
                changedItem.endDate = date as Date;
                handleGalleryItemChange(changedItem);
            }
            }
                selectsEnd
                startDate={item?.startDate}
                endDate={item?.endDate}
                minDate={item?.startDate} />
        </div>
    </Card.Body>
</Card>;
}
export default FileItem;
